import {useContext, useEffect, useState} from 'react';
import {NewsFeed} from '../queries/newsFeed';
import {NewsFeedContext} from '../state/newsFeedContext';

const useNewsFeed = () => {
  console.log('useNewsFeed');
  const {state, dispatch} = useContext(NewsFeedContext);
  const [offset, setOffset] = useState(1);
  const [limit, setLimit] = useState(3);
  const [maxOffset, setMaxOffset] = useState(1);

  useEffect(() => {
    console.log(state.length);
    state.length === 0 &&
      NewsFeed.getNewsFeed(offset, limit).then(response => {
        if (response?.data) {
          setMaxOffset(response.maxOffset);
          dispatch({type: 'initNewsFeed', payload: response.data});
        } else {
          dispatch({type: 'initNewsFeed', payload: [{type: 'empty'}]});
        }
      });
  }, []);

  const getNext = () => {
    NewsFeed.getNewsFeed(offset + 1, limit).then(response => {
      dispatch({type: 'addNewsFeed', payload: response.data});
      setOffset(offset + 1);
    });
  };

  const reload = () => {
    setOffset(1);
    NewsFeed.getNewsFeed(offset, limit).then(response => {
      if (response.data) {
        setMaxOffset(response.maxOffset);
        dispatch({type: 'initNewsFeed', payload: response.data});
      } else {
        dispatch({type: 'initNewsFeed', payload: [{type: 'empty'}]});
      }
    });
  };

  return {newsFeed: state ?? [], getNext, offset, maxOffset, reload};
};

export {useNewsFeed};
